import { defineMessages } from "react-intl";

export const messages = defineMessages({
  name: {
    id: "package.name",
    defaultMessage: "Name",
  },
  description: {
    id: "package.description",
    defaultMessage: "description",
  },
  translations: {
    id: "package.translations",
    defaultMessage: "Translations",
  },
  someFieldsHaveErrors: {
    id: "default.someFieldsHaveErrors",
    defaultMessage: "Some fields have errors",
  },
  tabsErrors: {
    id: "app.form.someTabsErrors",
    description: "error tabs text",
    defaultMessage: "Some tabs have errors.",
  },
  presenceValidator: {
    id: "app.input.pressence",
    description: "ticker validation text",
    defaultMessage: "doesn't allow blank spaces and special characters except underscore ( _ )",
  },
});
